export function formatValue(value: string): string | null {
    if (!value) {
        return null;
    }

    return value;
}
